export default __webpack_public_path__ + "static/media/art-0-pergola2.b523b56b.jpeg";